export default function knowledgebases(state = [], action) {
    switch (action.type) {
        case 'ADD_CURRENT':
            return {
                ...state,
                knowledgebase: action.knowledgebase,
            }
        default:
            return state;
    }
}
